<template>
  <div class="required-container">
    <div class="required-div">* {{ $t("Required") }}</div>
  </div>
</template>

<script>
export default {
  name: "FormRequired"
};
</script>

<style scoped>
.required-container {
  margin: 10px;
  height: 30px;
  border-top: solid 1px #cccccc;
}
.required-div {
  margin-top: 5px;
  font-weight: 300;
  color: #808080;
  font-style: italic;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/FormRequired.vue